import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import Workspace from 'common/components/Workspace';

import ScaledFormsLibraryModal from './ScaledFormsLibraryModal';

export const DEFAULT_RSVP_TITLE = 'Default RSVP Form';
export const USE_FORM_FROM_LIBRARY = 'Choose template from library';

const BASE_COMPONENT_NAME = 'ScaledFormsTopBarDropdown';

const ScaledFormsTopBarDropdown = (props) => {
    const formTitle = props.formName || DEFAULT_RSVP_TITLE;
    const [title, setTitle] = useState(formTitle);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        setTitle(formTitle);
    }, [formTitle]);

    const toggleScaledFormsModal = (event, value) => {
        if (value === USE_FORM_FROM_LIBRARY) {
            setTitle(value);
            setOpen(true);
        }
    };

    const onCloseModal = () => {
        setTitle(formTitle);
        setOpen(false);
    };

    return (
        <React.Fragment>
            <Workspace.Topbar.Dropdown
                dataQa={BASE_COMPONENT_NAME}
                onChange={toggleScaledFormsModal}
                value={title}
                options={[
                    {
                        label: formTitle,
                        value: formTitle,
                    },
                    {
                        label: USE_FORM_FROM_LIBRARY,
                        value: USE_FORM_FROM_LIBRARY,
                    },
                ]}
                subtitle={props.subtitle}
            />
            <ScaledFormsLibraryModal open={open} onClose={onCloseModal} />
        </React.Fragment>
    );
};

ScaledFormsTopBarDropdown.propTypes = {
    subtitle: PropTypes.string.isRequired,
    formName: PropTypes.string.isRequired,
};

export default ScaledFormsTopBarDropdown;
